<script setup lang="ts">
import { PageProps } from "./Page.props"

defineProps<PageProps>()
</script>

<template>
  <div class="generic-page page-wrapper">
    <div class="grid-standard md:pb-10">
      <div
        class="
          col-span-full
          space-y-4
          py-4
          md:col-span-10 md:col-start-2
          md:space-y-6
          md:py-6
        "
      >
        <p v-if="title" class="elephant-bold md:mammoth-bold">
          {{ title }}
        </p>

        <UtilsButton
          v-if="downloadButton"
          v-bind="downloadButton"
          class="
            custom-btn-underlined custom-btn-beaver custom-btn-no-padding
            inline-block
            cursor-pointer
            pt-3
          "
          theme="ghost-green"
        >
          <template #icon>
            <UtilsIcon name="Document.svg" color="green-main" class="h-5 w-5" />
          </template>
        </UtilsButton>

        <p v-if="description" class="dolphin-bold text-green-main">
          {{ description }}
        </p>

        <UtilsMarkdown
          v-if="content"
          :content="content"
          class="
            markdown__link-underlined
            markdown__link-green-main
            markdown__service-page
          "
          :inline="false"
        />
        <component
          v-if="$route.fullPath == customPaths.cookies"
          is="script"
          src="https://consent.cookiebot.com/03630b40-6990-4bda-900c-8f6eb5f71c03/cd.js"
          async
          type="text/javascript"
        />
      </div>

      <ContactFaq
        class="col-span-full md:col-span-10 md:col-start-2"
        v-if="faq"
        v-bind="faq"
      />

      <ServicesFeedback
        :resource="title"
        class="negative-margined col-span-full md:col-span-10 md:col-start-2"
      />

      <ServicesCustomerService
        class="col-span-full md:col-span-10 md:col-start-2"
        v-if="customerService"
        v-bind="customerService"
      />
    </div>

    <CartUtilsLogin
      class="text-center"
      :upperText="$t('loginBanner.type2.upperText')"
      show-login-button
    />
  </div>
</template>
